import { toCamelCase, toSnakeCase } from '../strings/index.js';
/**
 * Type guard to check if value is a plain object
 */
function isPlainObject(value) {
    return (value !== null &&
        typeof value === 'object' &&
        !Array.isArray(value) &&
        !(value instanceof Date) &&
        !(value instanceof RegExp) &&
        !(value instanceof Error));
}
/**
 * Deeply converts all object keys to camelCase
 * Handles nested objects and arrays
 */
export function camelCaseKeysDeep(obj) {
    if (Array.isArray(obj)) {
        return obj.map(item => camelCaseKeysDeep(item));
    }
    if (isPlainObject(obj)) {
        const result = {};
        for (const [key, value] of Object.entries(obj)) {
            const camelKey = toCamelCase(key);
            result[camelKey] = camelCaseKeysDeep(value);
        }
        return result;
    }
    return obj;
}
/**
 * Deeply converts all object keys to snake_case
 * Handles nested objects and arrays
 */
export function snakeCaseKeysDeep(obj) {
    if (Array.isArray(obj)) {
        return obj.map(item => snakeCaseKeysDeep(item));
    }
    if (isPlainObject(obj)) {
        const result = {};
        for (const [key, value] of Object.entries(obj)) {
            const snakeKey = toSnakeCase(key);
            result[snakeKey] = snakeCaseKeysDeep(value);
        }
        return result;
    }
    return obj;
}
